import { computed, markRaw } from "vue";
import { PAGE_SECTION_TYPES } from "@/apps/page/services/page.service";
import { useI18n } from "vue-i18n";
import {
    CoffeeIcon,
    CookieIcon,
    FaqIcon,
    LegalIcon,
    LoveIcon,
    PricingIcon,
    TickerIcon,
} from "@easy/ui/icons";

export function useSections() {
    const { t } = useI18n();

    const sectionTypes = computed(() => {
        return [
            {
                tool: PAGE_SECTION_TYPES.LOVE,
                title: t("shared.list.testimonials.title"),
                createTitle: t("shared.list.testimonials.new"),
                emptyTitle: t("shared.list.testimonials.empty_title"),
                emptySubtitle: t("shared.list.testimonials.empty_subtitle"),
                icon: markRaw(LoveIcon),
            },
            {
                tool: PAGE_SECTION_TYPES.PRICING,
                title: t("shared.list.pricings.title"),
                createTitle: t("shared.list.pricings.new"),
                emptyTitle: t("shared.list.pricings.empty_title"),
                emptySubtitle: t("shared.list.pricings.empty_subtitle"),
                icon: markRaw(PricingIcon),
            },
            {
                tool: PAGE_SECTION_TYPES.FAQ,
                title: t("shared.list.faqs.title"),
                createTitle: t("shared.list.faqs.new"),
                emptyTitle: t("shared.list.faqs.empty_title"),
                emptySubtitle: t("shared.list.faqs.empty_subtitle"),
                icon: markRaw(FaqIcon),
            },
            {
                tool: PAGE_SECTION_TYPES.LEGAL,
                title: t("shared.list.legals.title"),
                createTitle: t("shared.list.legals.new"),
                emptyTitle: t("shared.list.legals.empty_title"),
                emptySubtitle: t("shared.list.legals.empty_subtitle"),
                icon: markRaw(LegalIcon),
            },
            {
                tool: PAGE_SECTION_TYPES.COOKIE,
                title: t("shared.list.cookies.title"),
                createTitle: t("shared.list.cookies.new"),
                emptyTitle: t("shared.list.cookies.empty_title"),
                emptySubtitle: t("shared.list.cookies.empty_subtitle"),
                icon: markRaw(CookieIcon),
            },
            {
                tool: PAGE_SECTION_TYPES.COFFEE,
                title: t("shared.list.coffees.title"),
                createTitle: t("shared.list.coffees.new"),
                emptyTitle: t("shared.list.coffees.empty_title"),
                emptySubtitle: t("shared.list.coffees.empty_subtitle"),
                icon: markRaw(CoffeeIcon),
            },
            {
                tool: PAGE_SECTION_TYPES.TICKER,
                title: t("shared.list.tickers.title"),
                createTitle: t("shared.list.tickers.new"),
                emptyTitle: t("shared.list.tickers.empty_title"),
                emptySubtitle: t("shared.list.tickers.empty_subtitle"),
                icon: markRaw(TickerIcon),
            },
        ];
    });

    function getAllSectionTypes() {
        return sectionTypes.value;
    }

    function getSectionTypeByTool(tool: string) {
        return sectionTypes.value.find((section) => section.tool === tool);
    }

    return {
        getAllSectionTypes,
        getSectionTypeByTool,
        sectionTypes,
    };
}
